import { ScanMode, ScanScope } from '../../api/issues';

/** What the scope editor shows: the mode and, for "selected", the chosen environments. */
export interface ScopeChoice {
    mode: ScanMode;
    environments: string[];
}

/**
 * The saved values of a scope as one string. The panel reloads every few seconds and hands
 * over a new object each time; only a different string means someone saved something.
 */
export const scopeSignature = (scope: ScanScope): string =>
    [scope.mode, [...scope.environments].sort().join(','), scope.changedAt ?? ''].join('|');

/** Whether two choices scan the same: the environments only count for "selected". */
export const sameChoice = (a: ScopeChoice, b: ScopeChoice): boolean =>
    a.mode === b.mode &&
    (a.mode !== 'selected' ||
        (a.environments.length === b.environments.length && b.environments.every((e) => a.environments.includes(e))));

/**
 * Whether the editor takes over the saved scope: only when what is saved changed since the
 * editor last took it over, and the choice on screen is not an unsaved change of its own -
 * unless it is exactly what got saved, as after pressing save.
 */
export const takeOverSaved = (base: ScanScope, saved: ScanScope, local: ScopeChoice): boolean =>
    scopeSignature(saved) !== scopeSignature(base) && (sameChoice(local, base) || sameChoice(local, saved));
